<!-- Interaction Setup Options Component -->
<div class="interaction-setup-options">
    <div class="logic-action-container">
        <div class="btn-group" role="group">
            <button type="button" class="btn btn-default" [class.btn-green]="conditionForOptionSelected === 'display'"
                [disabled]="readOnly" (click)="toggleConditionTab('display') ">
                Display
            </button>
            <button type="button" class="btn btn-default" [class.btn-green]="conditionForOptionSelected === 'custom'"
                [disabled]="readOnly" (click)="toggleConditionTab('custom')">
                Custom
            </button>
        </div>
    </div>

    <div class="options-condition-container">
        <div class="options-table-container">
            <table class="table options-table">
                <thead>
                    <tr>
                        <th class="col-md-4 label-text">
                            Options Names
                        </th>
                        <th class="col-md-8 label-text">
                            Conditions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let option of interaction.sub_questions">
                        <td class="col-md-4">
                            <!-- [matTooltip]="option.text" add for option text -->
                            <div class="option-text">
                                <span class="setup-condition-option-container">
                                    <b>{{option.text}}</b>
                                </span>
                            </div>
                        </td>
                        <td class="col-md-8">
                            <div class="condition-container">
                                <div *ngIf="showDisplay && subQuestionMap[option?.field_id].isDisplayConditionActive">
                                    <div class="condition-logic"
                                        *ngFor="let logic of this.logicDetailsMap[option?.field_id].logicDetail[1].transformString;index as logicIndex; first as isFirst">
                                        <!-- Logical Operator -->
                                        <!-- logic: {{logic|json}} -->
                                        <div *ngIf="!isFirst" class="margin-bottom-10 margin-top-10">
                                            <div class="btn-group" role="group">
                                                <button type="button" class="btn"
                                                    [class.btn-primary]="logic.logicalOptr === operator.op"
                                                    [class.btn-default]="logic.logicalOptr !== operator.op"
                                                    [disabled]="readOnly"
                                                    *ngFor="let operator of operators.logical"
                                                    (click)="updateConditionForLogicOpt(option?.field_id,logic, operator.op)">
                                                    {{operator.text}}
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Condition Display -->
                                        <div *ngIf="logic.isValid" class="row condition-edit-container">
                                            <div class="col-10 question-condition">
                                                <span *ngIf="logic.target === 'target_value'">
                                                    {{getQuestionText(logic.interaction)}}
                                                    <span class="operator-text">
                                                        {{operatorsMap[logic.comparisonOptr] || logic.comparisonOptr}}
                                                    </span>
                                                    {{logic.value.value?.toString() || logic.value}}
                                                </span>
                                                <span *ngIf="logic.target === 'target_field'">
                                                    {{getQuestionText(logic.interaction)}}
                                                    <span class="operator-text">
                                                        {{operatorsMap[logic.comparisonOptr] || logic.comparisonOptr}}
                                                    </span>
                                                    {{getQuestionText(logic.targetInteraction)}}
                                                </span>
                                            </div>
                                            <div class="col-2">
                                                <button class="btn-icon" [disabled]="readOnly" (click)="openEditContainer(option?.field_id,logic)">
                                                    <i class="fa fa-edit"></i>
                                                </button>
                                                <button class="btn-icon" [disabled]="readOnly"
                                                    (click)="closeCondition(option?.field_id,logicIndex)">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <!-- Condition Edit Form -->
                                        <div *ngIf="showDisplay && isDisplayConditionActive && logic.isOpen"
                                            [id]="'conditionEditContainer_' + logicIndex" class="condition-edit-form">
                                            <form #conditionForm="ngForm" class="condition-form">
                                                <div class="row">
                                                    <div class="col-sm-11">
                                                        <!-- Question Selection -->
                                                        <div class="form-group">
                                                            <select class="form-control" [disabled]="readOnly" [(ngModel)]="logic.interaction"
                                                                name="interaction"
                                                                (change)="updateTransitionObject(option?.field_id, logicIndex, logic)"
                                                                required>
                                                                <option value="" disabled>Select Question</option>

                                                                <ng-container
                                                                    *ngFor="let question of questionMaps[option.field_id].questions;">
                                                                    <option [value]="question?.field_id"
                                                                        *ngIf="isQuestion(question) && question?.field_id">
                                                                        {{question?.text}}
                                                                    </option>
                                                                    <optgroup [label]="question?.text"
                                                                        *ngIf="isQuestionGroup(question) && question?.field_id">
                                                                        <option [value]="opt.field_id"
                                                                            *ngFor="let opt of question?.options">
                                                                            {{opt.text}}</option>
                                                                    </optgroup>
                                                                </ng-container>
                                                            </select>
                                                        </div>


                                                        <div class="form-group input-group">
                                                            <!-- Comparison Operator -->
                                                            <select class="form-control"
                                                                [disabled]="readOnly || !logic.interaction"
                                                                [(ngModel)]="logic.comparisonOptr" name="comparisonOptr"
                                                                required>
                                                                <option value="" disabled>Select Operator</option>
                                                                <option
                                                                    *ngFor="let operator of operators.comparison"
                                                                    [value]="operator.op">
                                                                    {{operator.text}}
                                                                </option>
                                                            </select>
                                                            <!-- Target Type -->
                                                            <select class="form-control" [disabled]="readOnly || !logic.comparisonOptr" [(ngModel)]="logic.target"
                                                                name="target"
                                                                required>
                                                                <option value="" disabled>Select Target</option>
                                                                <option value="target_value">Value</option>
                                                                <option value="target_field">Question</option>
                                                            </select>
                                                            <!-- Target Value/Field -->
                                                            <select class="form-control" [disabled]="readOnly" [(ngModel)]="logic.value"
                                                                name="value"
                                                                *ngIf="!logic.target || logic.target === 'target_value'"
                                                                (change)="selectionChanged(option?.field_id ,logic, logicIndex)"
                                                                required>
                                                                <option value="" disabled>Select Value</option>
                                                                <option *ngFor="let config of logic.configuration"
                                                                    [value]="config.value">
                                                                    {{config.label}} ({{config.value}})
                                                                </option>
                                                            </select>

                                                            <select class="form-control" [disabled]="readOnly"
                                                                [(ngModel)]="logic.targetInteraction"
                                                                name="targetInteraction"
                                                                *ngIf="logic.target === 'target_field'" required>
                                                                <option value="" disabled>Select Question</option>
                                                                <ng-container
                                                                    *ngFor="let question of questionMaps[option.field_id].values;">
                                                                    <option [value]="question?.field_id"
                                                                        *ngIf="isQuestion(question) && question?.field_id">
                                                                        {{question?.text}}
                                                                    </option>
                                                                    <optgroup [label]="question?.text"
                                                                        *ngIf="isQuestionGroup(question) && question?.field_id">
                                                                        <option [value]="opt.field_id"
                                                                            *ngFor="let opt of question?.options">
                                                                            {{opt.text}}</option>
                                                                    </optgroup>
                                                                </ng-container>
                                                            </select>
                                                        </div>


                                                    </div>
                                                    <div class="col-sm-1 condition-btn-group">
                                                        <button type="button" class="btn btn-success btn-circle"
                                                            [disabled]="readOnly || !conditionForm.valid"
                                                            (click)="addCondition(option?.field_id,logic)">
                                                            <i class="fa fa-check"></i>
                                                        </button>
                                                        <button type="button" class="btn btn-danger btn-circle" [disabled]="readOnly"
                                                            (click)="closeCondition(option?.field_id,logicIndex)">
                                                            <i class="fa fa-times"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>

                                <!-- Custom Condition -->
                                <div *ngIf="showCustom && conditionForOptionSelected === 'custom'">
                                    <div class="custom-condition-form">
                                        <div class="form-group">
                                            <label>Provide Custom Expression</label>
                                            <textarea class="form-control" [disabled]="readOnly" placeholder="Provide custom expression"
                                                [(ngModel)]="logicDetailsMap[option?.field_id].logicDetail[3].logicString"
                                                (blur)="updateCurrentCondition(option?.field_id ,3)">
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary add-condition" *ngIf="conditionForOptionSelected === 'display' "
                                [disabled]="readOnly || !isAddButtonEnabled(option?.field_id)" (click)="toggleForAddCondition(option?.field_id)" >
                                Add Condition
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>